import type { SimpleHeadlineResponse } from '@on3/api';
import { On3IconLockPremium } from '@on3/icons';
import { Link } from '@on3/ui-lib/components/Link';
import { Text } from '@public/components/UI/Typography/Text';
import { format } from 'date-fns';
import type { FC } from 'react';

import styles from './TransferPortalArticle.module.scss';

export const TransferPortalArticle: FC<SimpleHeadlineResponse> = ({
  isPremium,
  title,
  datePublishedGmt,
  fullUrl,
}) => {
  return (
    <div className={styles.articleContainer}>
      <div className={styles.textWrapper}>
        <Text className={styles.updateText} variant="subtitle1">
          Update:
        </Text>
        <Text className={styles.date} variant="caption">
          {datePublishedGmt
            ? format(new Date(`${datePublishedGmt}.000Z`), 'M/dd/yy')
            : ''}
        </Text>
      </div>
      <Link className={styles.articleLink} href={fullUrl}>
        {title}
      </Link>
      {isPremium && (
        <div>
          <On3IconLockPremium />
        </div>
      )}
    </div>
  );
};
